import { Record } from "immutable";
import { moment } from "../../utils";
import store from "../../reducers/store";

const TeserListItemRecord = new Record({
  id: null,
  cid: null,

  title: "",
  desc: "",
  url: "",
  image: "",
  cpc: 0,

  add_date: "",
  edit_date: "",

  status: null,
  comment: "",
  checked: false,

  rank: {
    rank: undefined,
    rank_mobile: undefined
  },

  stat: {
    clicks: 0,
    shows: 0,
    ctr: 0,
    spent: 0,
    cpc: 0
  }
});

export default class TeaserListItem extends TeserListItemRecord {
  getImageUrl() {
    const { config } = store.getState();

    return config.teaserImgUrl(this.image, "70_70");
  }

  getAddDate() {
    return moment(this.add_date).format("D MMM Y");
  }

  getEditDateFromNow() {
    return moment(this.edit_date).fromNow();
  }
}
